import React from 'react';
import { Tooltip, Button, Icon } from 'antd';
import { useDispatch } from 'react-redux';
import { searchToggleSelectAll } from '..';
import { getDataTypeName } from 'common';
import { ResultTypeName } from '../Search.types';

const ButtonGroup = Button.Group;

const SearchSelectAll: React.FC<{
  resultItemIndex: number;
  documentType: string;
  tabName: string;
  selected: number;
  count: number;
  resultType: ResultTypeName;
}> = ({
  resultItemIndex,
  documentType,
  tabName,
  selected,
  count,
  resultType,
}) => {
  const dispatch = useDispatch();

  return (
    <ButtonGroup>
      <Tooltip title={`Select ${count} records from the table`}>
        <Button
          onClick={() =>
            dispatch(
              searchToggleSelectAll(
                getDataTypeName(tabName),
                documentType,
                true,
                resultItemIndex,
                resultType,
              ),
            )
          }
          disabled={count === 0 || count === selected}
        >
          <Icon type="check" />
        </Button>
      </Tooltip>
      <Tooltip title={`Unselect ${count} records from the table`}>
        <Button
          onClick={() =>
            dispatch(
              searchToggleSelectAll(
                getDataTypeName(tabName),
                documentType,
                false,
                resultItemIndex,
                resultType,
              ),
            )
          }
          disabled={count === 0 || selected === 0}
        >
          <Icon type="close" />
        </Button>
      </Tooltip>
    </ButtonGroup>
  );
};

export default SearchSelectAll;
